import axios from '@/config/axios'

const formsTemplate = '/v1/api/mg/formType';


export const formType = (query) => axios.get(`${formsTemplate}`, {params: query})


export const addForm = (forms) => axios.post(`${formsTemplate}`, forms)

export const update = (forms) => axios.put(`${formsTemplate}/${forms.id}`, forms)


export const deleteForm = (id) => axios.delete(`${formsTemplate}/${id}`)

export const formsOrderBase = "/v1/api/mg/formsOrders"

export const formsOrders = (query) => axios.get(`${formsOrderBase}`, {
    params: query, headers: {
        "request": "dto"
    }
})

export const exportFormsOrders = (query) => axios.get(`${formsOrderBase}`, {
    params: query,
    headers: {
        Accept: "application/vnd.ms-excel"
    },
    responseType: 'arraybuffer'
})


export const getOrderPdf = (id) => axios.get(`${formsOrderBase}/${id}`, {
    headers: {
        Accept: "application/pdf"
    },
    responseType: 'arraybuffer'
})
